/**
 * Canonical Wagamour V2 button tokens.
 *
 * Primary = Home sunrise CTA. Secondary = warm glass (not gray/white).
 * Destructive = red semantic accent in the same glass family.
 */

import { homeV2Gradients, homeV2Glass, homeV2Text } from '@/lib/home/homeV2Theme'
import { wagamourV2SurfaceBlur } from '@/lib/design/v2Surface'

export type WagamourV2ButtonVariant = 'primary' | 'secondary' | 'destructive'

export type WagamourV2ButtonToken = {
  background: string
  color: string
  border: string
  boxShadow: string
  backdropFilter?: string
  WebkitBackdropFilter?: string
}

const primaryShadow =
  '0 4px 18px rgba(251, 146, 60, 0.38), 0 2px 8px rgba(244, 114, 182, 0.22), inset 0 1px 0 rgba(255, 255, 255, 0.35)'

const secondaryEdge = 'inset 0 1px 0 rgba(255, 235, 200, 0.38)'
const secondaryShadow =
  `${secondaryEdge}, inset 0 0 40px rgba(255, 160, 70, 0.10), 0 6px 20px rgba(0, 0, 0, 0.18)`

const destructiveShadow =
  'inset 0 1px 0 rgba(254, 202, 202, 0.32), 0 6px 20px rgba(127, 29, 29, 0.28), 0 2px 8px rgba(0, 0, 0, 0.14)'

export const wagamourV2Button: Record<WagamourV2ButtonVariant, WagamourV2ButtonToken> = {
  primary: {
    background: homeV2Gradients.sunrise,
    color: homeV2Text.headline,
    border: 'rgba(255, 240, 220, 0.28)',
    boxShadow: primaryShadow,
  },
  secondary: {
    background: homeV2Glass.nested.background,
    color: homeV2Text.primary,
    border: homeV2Glass.nested.border,
    boxShadow: secondaryShadow,
    backdropFilter: `blur(${wagamourV2SurfaceBlur})`,
    WebkitBackdropFilter: `blur(${wagamourV2SurfaceBlur})`,
  },
  destructive: {
    background:
      'linear-gradient(165deg, rgba(127, 29, 29, 0.48) 0%, rgba(153, 27, 27, 0.36) 55%, rgba(185, 28, 28, 0.28) 100%)',
    color: '#FECACA',
    border: 'rgba(248, 113, 113, 0.44)',
    boxShadow: destructiveShadow,
    backdropFilter: `blur(${wagamourV2SurfaceBlur})`,
    WebkitBackdropFilter: `blur(${wagamourV2SurfaceBlur})`,
  },
}
